import * as React from 'react';
import { ExpiryDate } from '../Types/Payments/PaymentDetails';
import MonthAndYearPicker from './MonthAndYearPicker';

interface Props {
  id?: string;
  label?: string;

  value?: ExpiryDate;

  forceHighlightErrors?: boolean;

  displayOptions?: {
    divClassName?: string;
    labelClassName?: string;
    monthSelectClassName?: string;
    yearSelectClassName?: string;
    selectClassName?: string;
  };

  onChange(value: ExpiryDate): void;
}

class ExpiryDateInput extends React.Component<Props> {

  generateYearsList = () => {
    const thisYear = new Date().getFullYear();
    let list: Number[] = [];

    for (let i = 0; i < 10; i++) {
      list.push(thisYear + i);
    }

    return list;
  };

  validateInFuture = (date: { month: string, year: string }): { valid: number, failedValidationMessage?: string } => {
    const now = new Date();
    if (date.month === '' || date.year === '') {
        return { valid: 1, failedValidationMessage: 'A date must be selected.' };
    }

    const inputDate = new Date(Number(date.year) + 2000 , Number(date.month) - 1);
    if (inputDate >= now) {
        return { valid: 0, failedValidationMessage: '' };
    }

    return { valid: 2, failedValidationMessage: 'Expiry date must be in the future' };
  }

  render() {

    return (
      <>
        <MonthAndYearPicker
          title={this.props.label || 'Expiry Date'}
          value={{
            month: this.props.value ? this.props.value.month : '',
            year: this.props.value ? this.props.value.year : '',
          }}
          displayOptions={this.props.displayOptions}
          validation={{
            validator: this.validateInFuture,
            forceHighlightErrors: this.props.forceHighlightErrors,
          }}
          years={this.generateYearsList()}

          dateChanged={(date) => {
            this.props.onChange({ month: date.month, year: date.year.toString() });
          }}
        />
      </>
    );
  }
}

export default ExpiryDateInput;



// WEBPACK FOOTER //
// ./src/Components/ExpiryDateInput.tsx